import React from 'react'
import * as TwoStepPaymentForm from 'common/components/entities/TwoStepPaymentForm'
import FieldErrors from 'publisher/components/FieldErrors'
import { TwoStepPaymentButtonProps } from 'publisher/components/entities/TwoStepPaymentForm/TwoStepPaymentButtonProps'
import useManagement, {
  selectors as managementSelectors,
} from 'publisher/hooks/useManagement'
import useSecureAndPayPaymentHandler from 'publisher/hooks/payment/useSecureAndPayPaymentHandler'

const TwoStepSecureAndPayPaymentButton = ({
  entity,
  styles,
  mobileStyles,
}: TwoStepPaymentButtonProps) => {
  const { isLoading, handleSubmit, errors } =
    useSecureAndPayPaymentHandler(entity)

  const isPreview = useManagement(managementSelectors.isPreviewMode)

  return (
    <React.Fragment>
      <TwoStepPaymentForm.Button
        onClick={handleSubmit}
        styles={styles}
        mobileStyles={mobileStyles}
        text={entity.options.buttonText}
        subText={entity.options.buttonSubText}
        disabled={isLoading || isPreview}
      />
      <FieldErrors errors={errors} />
    </React.Fragment>
  )
}

export default TwoStepSecureAndPayPaymentButton
